import React from 'react';
import { MenuItem } from '@mui/material';
import { FormInputText } from '../../../form-components/FormInputText';
import { FormInputDropdown } from '../../form/FormInputDropdown';
import { useTranslation } from 'react-i18next';

import {
  FormFieldRow,
  FormFieldGroupHalf,
  FormFieldLabel,
  dropdownStyle,
  textInputStyle,
  DropdownArrowIcon,
} from '../../SalesManagment/modal/enterSaleInfoModal/EnterSaleInfoModalStyled';

// 카드사 목록
export const CARD_COMPANIES = [
  { value: 'P001', label: '비씨(페이북)' },
  { value: 'P002', label: 'KB Pay(국민)' },
  { value: 'P003', label: '하나' },
  { value: 'P004', label: '삼성' },
  { value: 'P005', label: '신한' },
  { value: 'P006', label: '현대' },
  { value: 'P007', label: '롯데' },
  { value: 'P008', label: 'NH농협' },
  { value: 'P009', label: '씨티(구.한미)' },
  { value: 'P011', label: '우리' },
  { value: 'P012', label: '신협' },
  { value: 'P013', label: '광주' },
  { value: 'P014', label: '전북' },
  { value: 'P015', label: '제주' },
  { value: 'P016', label: '우체국' },
  { value: 'P017', label: 'MG 새마을금고' },
  { value: 'P018', label: '저축은행' },
  { value: 'P019', label: '카카오뱅크' },
];

// 할부 개월 옵션
export const INSTALLMENT_OPTIONS = [
  { value: '00', label: '일시불' },
  { value: '01', label: '1개월' },
  { value: '02', label: '2개월' },
  { value: '03', label: '3개월' },
  { value: '04', label: '4개월' },
  { value: '05', label: '5개월' },
  { value: '06', label: '6개월' },
  { value: '07', label: '7개월' },
  { value: '08', label: '8개월' },
  { value: '09', label: '9개월' },
  { value: '10', label: '10개월' },
  { value: '11', label: '11개월' },
  { value: '12', label: '12개월' },
];

const CardPaymentForm = ({ control, readOnly = false }) => {
  const { t } = useTranslation();

  return (
    <>
      {/* 할부기간 / 카드사 */}
      <FormFieldRow>
        <FormFieldGroupHalf>
          <FormFieldLabel>{t('할부기간')}</FormFieldLabel>
          <FormInputDropdown
            control={control}
            disabled={readOnly}
            sx={dropdownStyle}
            name="installmentMonth"
            options={INSTALLMENT_OPTIONS}
            disabledItem={<MenuItem disabled>{t('할부기간 선택')}</MenuItem>}
            IconComponent={DropdownArrowIcon}
          />
        </FormFieldGroupHalf>
        <FormFieldGroupHalf>
          <FormFieldLabel>{t('카드사')}</FormFieldLabel>
          <FormInputDropdown
            control={control}
            disabled={readOnly}
            sx={dropdownStyle}
            name="cardCompanyCode"
            options={CARD_COMPANIES}
            disabledItem={<MenuItem disabled>{t('카드사 선택')}</MenuItem>}
            IconComponent={DropdownArrowIcon}
          />
        </FormFieldGroupHalf>
      </FormFieldRow>

      {/* 카드번호 / 승인번호 */}
      <FormFieldRow>
        <FormFieldGroupHalf>
          <FormFieldLabel>{t('카드번호')}</FormFieldLabel>
          <FormInputText
            control={control}
            disabled={readOnly}
            color="info"
            sx={textInputStyle}
            variant="outlined"
            name="cardNumber"
            size="small"
            placeholder={t('카드 뒷 4자리를 입력해 주세요.')}
          />
        </FormFieldGroupHalf>
        <FormFieldGroupHalf>
          <FormFieldLabel>{t('승인번호')}</FormFieldLabel>
          <FormInputText
            control={control}
            disabled={readOnly}
            color="info"
            sx={textInputStyle}
            variant="outlined"
            name="approvalNumber"
            size="small"
            placeholder={t('승인번호를 입력해 주세요.')}
          />
        </FormFieldGroupHalf>
      </FormFieldRow>
    </>
  );
};

export default CardPaymentForm;
